import Vue from 'vue';
import BaseAdvancedSearch from '../../general/overview-grid/advanced-search';
import DateRange from '../../general/elements/daterange';
import DropDownList from '../../general/elements/dropdownlist';
import SuggestList from '../../general/elements/suggestlist';

export default Vue.component('advanced-search', {
    extends: BaseAdvancedSearch,
    template:`  
    <div v-show="advancedSearch.visible">
        <div class="row">
            <div class="col-md-3">
                <daterange :label="resources.advancedSearch.createdDateLabel" :placeholder="resources.advancedSearch.selectDatePlaceholder" :dateFrom.sync="queryParameters.createDateFrom" :dateTo.sync="queryParameters.createDateTo" />
            </div>
            <div class="col-md-3">
                <daterange :label="resources.advancedSearch.plannedDateLabel" :placeholder="resources.advancedSearch.selectDatePlaceholder" :dateFrom.sync="queryParameters.plannedDateFrom" :dateTo.sync="queryParameters.plannedDateTo" />
            </div>
            <div class="col-md-3">
                <daterange :label="resources.advancedSearch.pickedUpDateLabel" :placeholder="resources.advancedSearch.selectDatePlaceholder" :dateFrom.sync="queryParameters.pickedUpDateFrom" :dateTo.sync="queryParameters.pickedUpDateTo" />
            </div>
            <div class="col-md-3">
                <dropdownlist :value.sync="queryParameters.orderState" :settings="advancedSearch.state" :width="100" />
            </div>
            <div class="col-md-3">
                <dropdownlist :value.sync="queryParameters.queryYear" :settings="advancedSearch.years" :width="100" />
            </div>
            <div class="col-md-3">
                <suggestlist id="requester" :value.sync="queryParameters.requester" :settings="advancedSearch.requesters"/>
            </div>
            <div class="col-md-3">
                <suggestlist id="transporter" :value.sync="queryParameters.transporter" :settings="advancedSearch.transporters" />
            </div>
            <div class="col-md-3">
                <suggestlist id="receiver" :value.sync="queryParameters.receiver" :settings="advancedSearch.receivers" />
            </div>
            <div class="col-md-3">
                <label class="font-size-sm">{{ resources.advancedSearch.searchOnlyOrderCodesLabel }}</label>
                <div class="custom-control custom-switch">
                    <input class="custom-control-input" id="searchOnlyOrderCodes" type="checkbox" v-model="queryParameters.searchOnlyOrderCodes">
                    <label class="custom-control-label" for="searchOnlyOrderCodes">{{ resources.advancedSearch.searchOnlyOrderCodesLabel }}</label>
                </div>
            </div>
        </div>
        <div class="row mb-4">
            <div class="col-12 text-right">
                <button type="reset" v-on:click="resetAdvancedSearch" class="btn btn-sm btn-dual">
                    {{ resources.advancedSearch.reset }}
                </button>
                <button type="submit" v-on:click="applyAdvancedSearch" class="btn btn-sm btn-primary ml-1">
                    {{ resources.advancedSearch.apply }}
                </button>
            </div>
        </div>
        <hr>
    </div>
    `,
    components:{
        'daterange': DateRange,
        'dropdownlist': DropDownList,
        'suggestlist': SuggestList
    }
});